export default __webpack_public_path__ + "static/media/41_desktop.68ae796a.jpg";